import { getFunctions, httpsCallable } from "firebase/functions";
import app from "./firebaseApp";

const functions = getFunctions(app);

// Fonctions pour la gestion des droits admin
export const manageAdminRights = httpsCallable(functions, "manageAdminRights");
export const listAdminUsers = httpsCallable(functions, "listAdminUsers");
export const sendCustomPasswordResetEmail = httpsCallable<
  { email: string; tournamentKey?: string; frontBaseUrl?: string },
  { success: boolean }
>(functions, "sendCustomPasswordResetEmail");

export const listTournamentPayments = httpsCallable<
  { tournamentId: string },
  import("../types/TournamentPayment").TournamentPaymentsListResult
>(functions, "listTournamentPayments");

export const refundTournamentPayments = httpsCallable<
  {
    tournamentId: string;
    paymentIds: string[];
    confirmationToken: string;
  },
  import("../types/TournamentPayment").RefundTournamentPaymentsResult
>(functions, "refundTournamentPayments");

export const refundOrphanTournamentPayments = httpsCallable<
  {
    tournamentId: string;
    paymentIds: string[];
    confirmationToken: string;
  },
  import("../types/TournamentPayment").RefundTournamentPaymentsResult
>(functions, "refundOrphanTournamentPayments");

export default functions;
